import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Home.css';
import heroFrontDoor from './assets/heroDoor.jpg';
import crossSection from './assets/crossSection.jpg';
import closeUp from './assets/closeUp.jpg';
import doubleDoor from './assets/doubleDoor.jpg';
import distressed from './assets/distressed.jpg';
import topRailArch from './assets/topOfDoor.jpg';

function Home() {
  return (
    <div className="home-page">
      {/* HERO */}
      <section
        className="hero"
        style={{
          backgroundImage: `url(${heroFrontDoor})`,
        }}
      >
        <div className="hero-overlay" />
        <div className="hero-inner">
          <div className="hero-content">
            <div className="hero-copy-surface">
              <span className="hero-tagline">Imported European Doors</span>
              <h1 className="hero-heading">Luxury doors that transform your home.</h1>
              <p className="hero-subtitle">
                The finest imported wood without the mark up.
              </p>
              <div className="hero-ctas">
                <Link className="cta-button cta-button--primary" to="/product">
                  Shop Collections
                </Link>
                <a className="cta-button cta-button--ghost" href="#contact">
                  Talk to a specialist
                </a>
              </div>

              <div className="hero-stats">
                <div className="hero-stat">
                  <span className="hero-stat-label">Now serving the Western United States</span>
                  <span className="hero-stat-value">The best quality this side of the Mississippi</span>
                </div>
               
                <div className="hero-stat">
                  <span className="hero-stat-label">For</span>
                  <span className="hero-stat-value">trade & homeowners</span>
                </div>
              </div>
            </div>
          </div>

          <div className="hero-highlight-card">
          <div
              className="collection-image hero-highlight-image"
              style={{ backgroundImage: `url(${topRailArch})` }}
            />
            <span className="highlight-label">Featured</span>
            <h3 className="highlight-title">Top Rail Arch</h3>
            <p className="highlight-text">
              Premium Knotty Alder Wooden door in the with a top rail arch.
            </p>
            <p className="highlight-meta">Placeholder Price</p>
          </div>
        </div>
      </section>

      {/* COLLECTIONS / FEATURES */}
      <section id="features" className="section section-collections">
        <div className="section-header">
          <h2>Curated European collections</h2>
          <p>
            Three distinct lines, built to order and sized for your exact
            opening. Mix finishes, glass, and hardware for a tailored entrance.
          </p>
        </div>

        <div className="collection-grid">
          <article className="collection-card">
            <div
              className="collection-image"
              style={{ backgroundImage: `url(${crossSection})` }}
            />
            <div className="collection-body">
              <span className="collection-tag">Solid and Sturdy Design</span>
              <h3>Sleek, gallery-ready silhouettes</h3>
              <p>
                Clean lines, flush panels, and integrated pulls that suit
                contemporary architecture and high-end remodels.
              </p>
              <p className="collection-meta">Placeholder Price</p>
            </div>
          </article>

          <article className="collection-card">
            <div
              className="collection-image"
              style={{ backgroundImage: `url(${doubleDoor})` }}
            />
            <div className="collection-body">
              <span className="collection-tag">Double Doors</span>
              <h3>Glass, ironwork, and detail</h3>
              <p>
                Traditional profiles, divided-light glass, and hand-finished
                hardware for timeless curb appeal.
              </p>
              <p className="collection-meta">Placeholder Price</p>
            </div>
          </article>

          <article className="collection-card">
            <div
              className="collection-image"
              style={{ backgroundImage: `url(${distressed})` }}
            />
            <div className="collection-body">
              <span className="collection-tag"></span>
              <h3>Distressed Finishes</h3>
              <p>
                High-performance cores, precision edges, and a near-frameless
                look that disappears into the wall.
              </p>
              <p className="collection-meta">Placeholder Price</p>
            </div>
          </article>
        </div>
      </section>

      {/* VALUE PROPS */}
      <section className="section section-benefits">
        <div className="section-header section-header--center">
          <h2>Why Door Imports</h2>
          <p>
            We bridge European craftsmanship with US-ready specs, so your
            project installs smoothly and looks exceptional for decades.
          </p>
        </div>

        <div className="benefit-grid">
          <div className="benefit-item">
            <h3>Spec-driven support</h3>
            <p>
              Work directly with our team to review plans, rough openings, and
              hardware, so there are no surprises on site.
            </p>
          </div>
          <div className="benefit-item">
            <h3>Built to your project</h3>
            <p>
              Custom sizes, swing, glass, and finish options to match your
              architecture instead of forcing standard sizes.
            </p>
          </div>
          <div className="benefit-item">
            <h3>Nationwide logistics</h3>
            <p>
              Crated shipping, delivery scheduling, and documentation to keep
              your GC and installers on the same page.
            </p>
          </div>
        </div>
      </section>

      {/* ABOUT + VISUAL */}
      <section id="about" className="section section-about">
        <div className="about-layout">
          <div className="about-text">
            <h2>European doors, curated for the U.S.</h2>
            <p>
              Door Imports partners with established Italian, French, and German
              manufacturers to bring their best-selling models stateside.
            </p>
            <p>
              Every door is made-to-order, inspected before it leaves the
              factory, and prepared to integrate with standard US hardware and
              framing details.
            </p>
            <ul>
              <li>Premium veneers, metals, and glass</li>
              <li>Multi-point and smart-lock compatible</li>
              <li>Trade pricing for designers, builders, and architects</li>
            </ul>
          </div>
          <div className="about-image" aria-hidden="true">
            <div
              className="about-image-inner"
              style={{ backgroundImage: `url(${closeUp})` }}
            />
          </div>
        </div>
      </section>

      {/* CONTACT / CONSULTATION */}
      <section id="contact" className="section section-contact">
        <div className="contact-card">
          <h2>Start your door package</h2>
          <p>
            Share your plans or a rough opening and we&apos;ll recommend the
            right collection, glass, and hardware options for your project.
          </p>
          <div className="contact-details">
            <div>
              <span className="contact-label">Email</span>
              <a href="mailto:sales@doorimports.com">sales@doorimports.com</a>
            </div>
            <div>
              <span className="contact-label">Phone</span>
              <a href="tel:19492853122">(949) 285-3122</a>
            </div>
          </div>
          <a className="cta-button cta-button--full" href="mailto:info@doorimports.com">
            Email project details
          </a>
        </div>
      </section>
    </div>
  );
}

export default Home;
